import URL from '../url'
import Request from '../request'

/**
 * Suggest learning goals based on topic and current goals
 * @param {Object} requestData - The request data containing topic, currentGoals, attachmentIds, pageTitle (optional), and sectionTitle (optional)
 * @returns {Promise} - Promise that resolves to suggested goals
 */
export const CourseCreationSuggestGoalService = requestData => {
  return new Request(URL.APP_URL_LLM, URL.SUGGEST_GOAL).post(requestData)
}

/**
 * Suggest section titles based on topic, current goals, and current page titles
 * @param {Object} requestData - The request data containing topic, currentGoals, attachmentIds, and currentPageTitles
 * @returns {Promise} - Promise that resolves to suggested section titles
 */
export const CourseCreationSuggestSectionTitleService = requestData => {
  return new Request(URL.APP_URL_LLM, URL.SUGGEST_SECTION_TITLE).post(
    requestData,
  )
}

/**
 * Suggest page titles based on topic, current goals, and current page titles
 * @param {Object} requestData - The request data containing topic, currentGoals, attachmentIds, and currentPageTitles
 * @returns {Promise} - Promise that resolves to suggested page titles
 */
export const CourseCreationSuggestPageTitleService = requestData => {
  return new Request(URL.APP_URL_LLM, URL.SUGGEST_PAGE_TITLE).post(requestData)
}

/**
 * Suggest page outline goals based on topic, page title, section title, and current outline
 * @param {Object} requestData - The request data containing topic, pageTitle, sectionTitle, currentOutline, attachmentIds, and languageCode
 * @returns {Promise} - Promise that resolves to suggested page outline goals with response.suggestedOutline field
 */
export const CourseCreationSuggestPageOutlineService = requestData => {
  return new Request(URL.APP_URL_LLM, URL.SUGGEST_PAGE_OUTLINE).post(
    requestData,
  )
}
